'use client';

import React, { useEffect, useRef } from 'react';
import Link from 'next/link';

export default function HomeCTA() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal-on-scroll').forEach((el) => {
              (el as HTMLElement).classList.add('is-visible');
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 px-6 bg-primary">
      <div className="max-w-container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
          <div className="md:col-span-7 reveal-on-scroll">
            <div
              className="font-heading font-semibold text-white leading-tight mb-4"
              style={{ fontSize: 'clamp(1.75rem, 3.5vw, 3rem)', letterSpacing: '-0.025em' }}
            >
              SAC Planning done right takes structured thinking.
            </div>
            <p className="text-base font-body leading-relaxed mb-0" style={{ color: 'rgba(255,255,255,0.65)' }}>
              Start with a planning maturity assessment to identify gaps in your
              current SAC Planning architecture and define a structured path forward.
            </p>
          </div>
          <div className="md:col-span-5 flex flex-col gap-4 reveal-on-scroll reveal-delay-2">
            <Link
              href="/consulting-services"
              className="block text-center py-3 px-8 bg-white text-foreground font-body font-medium text-sm rounded border border-white hover:bg-secondary transition-colors duration-200"
            >
              Start with a Planning Assessment
            </Link>
            <a
              href="mailto:free10hours@sacplans.com"
              className="block text-center py-3 px-8 font-body font-medium text-sm rounded border transition-colors duration-200"
              style={{ borderColor: 'rgba(255,255,255,0.25)', color: 'rgba(255,255,255,0.75)' }}
            >
              free10hours@sacplans.com
            </a>
            <p className="text-center font-mono text-xs" style={{ color: 'rgba(255,255,255,0.4)' }}>
              Independent advisory · No vendor affiliation
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}